module.exports = __webpack_public_path__ + "static/monorepo-ce61274e7bdb9f1721e616ed3bfa3b4f.png";